import { ImportCounters } from "./import-counters";
import { ImportedPartner } from "./imported-partner";

export class ImportSummary {
  constructor(
    public readonly partners: ImportedPartner[],
    public readonly counters: ImportCounters,
  ) {}
}
